import {ThemeMode} from '@dropbox/dig-foundations';
import {atomWithStorage} from 'jotai/utils';

export const themePreferenceAtom = atomWithStorage<'auto' | ThemeMode>('theme_preference', 'auto');
